import { API_BASE } from './utils/apiBase';
// This runs when the app loads to keep the backend awake
const BACKEND_URL = API_BASE;

export function keepBackendAwake() {
  // Ping every 10 minutes
  setInterval(() => {
    fetch(`${BACKEND_URL}/api/health`).catch(() => {});
  }, 10 * 60 * 1000);
  
  // Also ping immediately on load
  fetch(`${BACKEND_URL}/api/health`).catch(() => {});
}
